export const urlBase = '##{api-url}##';
export const reCaptchaSiteKey = '##{recaptcha-site-key}##';